import { useContext } from "react";
import BaseActions, { APIRequestGenerator } from "base/BaseActions";
import BaseModel from "base/BaseModel";
import APIHelper from "base/APIHelper";
import UserModel from "./userModel";

const module = "importBatch";

const useImportBatchModel = () => {
  const { token, Organization } = useContext(UserModel.Context);

  const { getList, getOne, getConstant } = BaseActions(module, {
    token,
    Organization,
  });

  async function exportEntries(id, data) {
    const { url, headers } = APIRequestGenerator(
      `${process.env.REACT_APP_HOST}/${module}/${id}/exportEntries`,
      null,
      token,
    );
    try {
      const response = await APIHelper(
        "PUT",
        url.toString(),
        data,
        true,
        headers,
      );

      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  return {
    getList,
    getOne,
    getConstant,
    exportEntries,
  };
};

const ImportBatchModel = BaseModel(useImportBatchModel, "ImportBatchModel");

export { useImportBatchModel };
export default ImportBatchModel;
